import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

export default class extends Controller {
  static values = {
    url: String,
    id: String,
  };

  connect() {
    this.teardown = this.teardown.bind(this);
    this.onPageshow = (event) => {
      if (event.persisted) this.teardown();
    };
    // Android's WebView back/forward cache freezes the page mid-hide and
    // restores it later with an orphaned backdrop; Turbo's page cache can
    // snapshot the open modal when navigating via the native toolbar. Close
    // synchronously around both so no stale backdrop survives.
    window.addEventListener("pagehide", this.teardown);
    window.addEventListener("pageshow", this.onPageshow);
    document.addEventListener("turbo:before-cache", this.teardown);

    this.removeOrphanedBackdrops();
    this.openModal();
    this.markAsSeen();
  }

  disconnect() {
    window.removeEventListener("pagehide", this.teardown);
    window.removeEventListener("pageshow", this.onPageshow);
    document.removeEventListener("turbo:before-cache", this.teardown);
    this.teardown();
  }

  markAsSeen() {
    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": document.querySelector('[name="csrf-token"]').content,
        Accept: "application/json",
      },
    }).catch((error) => {
      console.error("Error marking notification as seen:", error.message);
    });
  }

  openModal() {
    const modal = new Modal(this.element);
    modal.show();
  }

  closeModal() {
    const modal = Modal.getOrCreateInstance(this.element);
    modal.hide();
  }

  // Synchronous close for page lifecycle events — Bootstrap's animated hide
  // can't finish once the page is frozen or the element detached
  teardown() {
    Modal.getInstance(this.element)?.dispose();
    this.element.classList.remove("show");
    this.element.style.display = "none";
    this.element.setAttribute("aria-hidden", "true");
    this.element.removeAttribute("aria-modal");
    this.element.removeAttribute("role");
    this.removeOrphanedBackdrops();
    document.body.classList.remove("modal-open");
    document.body.style.removeProperty("overflow");
    document.body.style.removeProperty("padding-right");
  }

  removeOrphanedBackdrops() {
    document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove());
  }
}
